import React, {useState, useEffect, useRef, Fragment} from 'react';
import axios from 'axios';
import 'c3/c3.css';
import c3 from 'c3';
import '../assets/css/Productivity.css';
import {API_BASE_URL} from "../config";
import Table from "../components/Table";
import Select from "react-select";
import ProductivityProjectDropdown from "../components/Productivity/ProductivityProjectDropdown";

const Productivity = () => {
    const [projects, setProjects] = useState([]);
    const [selectedProject, setSelectedProject] = useState(null);
    const [data, setData] = useState([]);
    const [dataForTable, setDataForTable] = useState([]);
    const chartRef = useRef(null);
    const [error, setError] = useState("Merci de sélectionner un projet");

    useEffect(() => {
        document.title = 'Productivité'
    }, []);
    // Fetch the list of projects
    useEffect(() => {
        axios.post(`${API_BASE_URL}/get_projects_distinct_with_finished_positions`)
            .then(response => {
                setProjects(response.data);
            })
            .catch(error => {
                console.error('Error fetching projects:', error);
                setError('Error fetching projects');
            });

    }, []);

    // Fetch productivity data when a project is selected
    useEffect(() => {
        if (selectedProject) {
            console.log(selectedProject);
            axios.post(`${API_BASE_URL}/get_productivity_positions`, {articleCode: selectedProject})
                .then(response => {
                    console.log("Data fetched:", response.data); // Log the response data
                    setData(response.data);
                    const sortedData = response.data.sort((a, b) => new Date(b.end_date) - new Date(a.end_date));
                    setDataForTable(sortedData);
                    setError(null)
                })
                .catch(error => {
                    console.error('Error:', error);
                    setError('Aucune donnée trouvée pour ce produit.');
                });
        }
    }, [selectedProject]);

    useEffect(() => {
        if (chartRef.current) {
            if (data.length > 0) {
                // French month names for the x-axis
                const frenchMonths = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];

                console.log(data)
                // Group data by year and month
                const dataByYear = {};
                data.forEach(item => {
                    if (item.end_date_project) {
                        // Extract year and month (assuming task_month is "YYYY-MM")
                        const [year, month] = item.end_date_project.split('-');
                        const monthIndex = parseInt(month, 10) - 1;

                        // Parse the avg_time_spent ("HH:MM:SS")
                        const [hours, minutes] = item.total_time_spent.split(':').map(Number);
                        const totalMinutesForOrder = hours * 60 + minutes;

                        // Initialize the year if needed with an array of 12 placeholders
                        if (!dataByYear[year]) {
                            dataByYear[year] = Array.from({length: 12}, () => ({sum: 0, count: 0}));
                        }

                        // Sum the minutes and count the items for that month
                        dataByYear[year][monthIndex].sum += totalMinutesForOrder;
                        dataByYear[year][monthIndex].count += 1;
                    }
                });

                // Build the series for C3: one series per year, each with 12 values (average hours per month)
                let columns = [];
                Object.keys(dataByYear).forEach(year => {
                    const series = [year];
                    dataByYear[year].forEach(({sum, count}) => {
                        // Calculate average (if count is 0, push null so that no bar is rendered)
                        series.push(count > 0 ? (sum / count) / 60 : null); // converting minutes to hours
                    });
                    columns.push(series);
                });

                // Optionally, sort the columns by year (ascending)
                columns.sort((a, b) => a[0] - b[0]);

                // Define colors for specific years (extend as needed)
                const colors = {
                    "2024": "var(--primary)", "2025": "var(--third)"
                    // add more year-to-color mappings if needed
                };

                // Generate the chart with multiple series
                chartRef.current.__chart = c3.generate({
                    bindto: chartRef.current, data: {
                        columns: columns, type: 'bar', colors: colors
                    }, axis: {
                        x: {
                            type: 'category', categories: frenchMonths, tick: {
                                rotate: -55, multiline: false
                            }, height: 130
                        }, y: {
                            label: {
                                text: 'Temps moyen (Heures)', position: 'outer-middle'
                            }, tick: {
                                format: d => {
                                    const hours = Math.floor(d);
                                    const minutes = Math.round((d - hours) * 60);
                                    return `${hours}h ${minutes}m`;
                                }
                            }
                        }
                    }, tooltip: {
                        format: {
                            title: (d) => `Mois: ${frenchMonths[d]}`, value: (value) => {
                                const hours = Math.floor(value);
                                const minutes = Math.round((value - hours) * 60);
                                return `${hours}h ${minutes}m`;
                            }
                        }, grouped: false
                    }, bar: {
                        width: {
                            ratio: 0.8
                        }
                    }
                });
            } else {
                // Clear the chart when there is no data
                chartRef.current.__chart = c3.generate({
                    bindto: chartRef.current, data: {
                        columns: [['Heures totales', 0]], type: 'bar'
                    }, axis: {
                        x: {
                            type: 'category', categories: [],
                        }, y: {
                            label: {
                                text: 'Heures totales', position: 'outer-middle'
                            }
                        }
                    }
                });
            }
        }
    }, [data, chartRef, selectedProject]);

    useEffect(() => {
        console.log(data)
    }, [data]);


    return (<div className={"display-flex flex-direction-column gap-20"}>
        <h2 className={"color-third"}>Productivité</h2>
        <div>
            <div className={"container chart-container p-20"}>
                <div className={"display-flex gap-10 flex-direction-column"}>
                    <h3 className={"color-third"}>Rechercher parmi tous les produits</h3>
                    {<div className={"search-bar container flex-1 m-0 bg-third"}>
                        <Select

                            noOptionsMessage={() => 'Aucun résultat trouvé'}
                            placeholder='Par exemple "solutionWEB PRO"'
                            options={projects.map((project, idx) => ({
                                key: idx, id: project.id,  // Use id for key
                                value: project.intern_code,  // Use intern_code for value
                                label: project.intern_code + " " + project.intern_name  // Display both intern_code and intern_name
                            }))}
                            value={selectedProject}
                            onChange={(selectedOption) => {

                                const selectedProject = selectedOption.value; // Use the intern_code directly
                                setSelectedProject(selectedProject);  // Set the correct project intern_code
                            }}
                            isClearable={true}
                            styles={{
                                container: (provided) => ({
                                    ...provided, width: "100%", position: "relative"
                                }), control: (provided) => ({
                                    ...provided, width: "100%", textAlign: "left", height: "51px", borderRadius: 8, // Add left padding to account for the icon
                                    paddingLeft: "45px"
                                }),
                            }}
                        />
                    </div>}
                </div>
                <div className={"mt-20"}>
                    <h3 className={"color-third"}>Sélection rapide...</h3>
                </div>


                <div className={"display-flex gap-50"}>
                    <div className="display-flex mt-20 flex-direction-column gap-20 flex">
                        <ProductivityProjectDropdown
                            title="solutionWEB"
                            options={[
                                {value: "231", label: "solutionWEB Basic"},
                                {value: "228", label: "solutionWEB Standard"},
                                {value: "225", label: "solutionWEB Pro"},
                                {value: "222", label: "solutionWEB ASSO BASIC"},
                                {value: "221", label: "solutionWEB ASSO STAND"},
                                {value: "317", label: "solutionWEB ASSO PRO"},
                            ]}
                            selectedProject={selectedProject}
                            setSelectedProject={setSelectedProject}
                        />

                        <ProductivityProjectDropdown
                            title="solutionWEB PREMIUM"
                            options={[
                                {value: "433", label: "solutionWEB PREMIUM Stand"},
                                {value: "432", label: "solutionWEB PREMIUM Pro"},
                            ]}
                            selectedProject={selectedProject}
                            setSelectedProject={setSelectedProject}
                        />

                    </div>

                    <div className="display-flex mt-20 flex-direction-column gap-20 flex">

                        <ProductivityProjectDropdown
                            title="solutionPOST"
                            options={[
                                {value: "186", label: "solutionPOST 12 (Renouvellement)"},
                                {value: "265", label: "solutionPOST 24"},
                                {value: "266", label: "solutionPOST 48"},
                                {value: "311", label: "solutionPOST 72"},
                                {value: "267", label: "solutionPOSTBOOSTER (3 mois)"}
                            ]}
                            selectedProject={selectedProject}
                            setSelectedProject={setSelectedProject}
                        />

                        <ProductivityProjectDropdown
                            title="solutionPOST PREMIUM"
                            options={[
                                {value: "358", label: "solutionPOST 12 PREMIUM"},
                                {value: "312", label: "solutionPOST 24 PREMIUM"},
                                {value: "300", label: "solutionPOST 48 PREMIUM"},
                                {value: "313", label: "solutionPOST 72 PREMIUM"},
                                {value: "314", label: "solutionPOST 96 PREMIUM"}
                            ]}
                            selectedProject={selectedProject}
                            setSelectedProject={setSelectedProject}
                        />

                    </div>
                    <div className="display-flex mt-20 flex-direction-column gap-20 flex">

                        <ProductivityProjectDropdown
                            title="solutionIDENTITE"
                            options={[
                                {value: "264", label: "solutionCHARTE GRAPHIQUE Basic"},
                                {value: "253", label: "solutionCHARTE GRAPHIQUE Pro"},
                                {value: "187", label: "solutionLOGO"},
                                {value: "376", label: "Logo pour promotion immobilière" },
                            ]}
                            selectedProject={selectedProject}
                            setSelectedProject={setSelectedProject}
                        />
                        <ProductivityProjectDropdown
                            title="solutionCARD"
                            options={[
                                {value: "176", label: "solutionCARD 240"},
                                {value: "269", label: "solutionCARD 480"},
                                {value: "334", label: "solutionCARD 960"},
                                {value: "430", label: "solutionCARD 240 PREMIUM"},
                                {value: "333", label: "solutionCARD 480 PREMIUM"},
                                {value: "335", label: "solutionCARD 960 PREMIUM"}
                            ]}
                            selectedProject={selectedProject}
                            setSelectedProject={setSelectedProject}
                        />
                    </div>
                </div>
            </div>
        </div>

        {selectedProject && (<>
            <div className={"chart-container"}>
                {error && <p>{error}</p>}
                <div className={""} style={{height: "500px"}} ref={chartRef}/>
            </div>

            {(data.length > 0) && (<div className={"chart-container"}>
                <h2 className={"text-left"}><i className={"fa-solid fa-chart-line"}/> Moyennes </h2>
                <Table
                    data={dataForTable}
                    showActions={false}
                    hidePagination={false}
                    maxEntries={10}
                    headers={["N° Bexio", "Projet", "Client", "Date de fin de projet", "Temps passé", "Montant brut", "Tarif/Temps passé (prix à l'heure)"]}
                    headersData={['order_id', 'title', 'contact_name', 'end_date_project', 'total_time_spent', 'order_completed_amount', "avg_price_per_time_spent"]}
                />
                <div className={"display-flex"}>
                </div>
            </div>)}
        </>)}

    </div>);
};

export default Productivity;
